<template>
  <div>
    <div id="page1-div" class="container interline border page-container">
      <div class="col-12 text-justify p-5">
        <div class="row">
          <div class="col-12 text-center pt-2">
            <span class="ft11Black">
              ACTA DE RECEPCIÓN DE BIENES
              <br />
              <hr />
            </span>
          </div>
        </div>
        <div class="col-12 text-right">
          ________ A ________________
          <br />
        </div>
        <div class="col-12 m-4">
          <span class="ft13">
            <br />
            GPI AUTO COMERCIAL SAPI DE CV
          </span>
          <br />

          <br /><br />
          <br />
          <span class="ft12">
            <span>
              Estimados señores en la ciudad ____________________ y siendo las ___ horas del
              día _____ después de haber revisado las condiciones físicas y
              mecánicas, mismas con las que estoy de acuerdo, recibo por parte de
              __________________el vehículo con las
              siguientes características: </span><br />
          </span>
          <br /><br />

          <div class="ft12 text-center">
            <span class="ft12Black"> MARCA:</span>
            <span>{{ data.marca_vehiculo || "____________________" }}</span>
            <span class="ft12Black"> AÑO:</span>
            <span>{{ data.año_vehiculo || "____________________" }}</span>
            <span class="ft12Black"> MODELO:</span>
            <span>{{ data.modelo_vehiculo || "____________________" }}</span><br />
            <br />
            <span class="ft12Black">NO. SERIE:</span>
            <span>{{ data.numero_serie_vehiculo || "____________________" }}</span>
            <span class="ft12Black">NO. MOTOR:</span>
            <span>{{ data.numero_motor_vehiculo || "____________________" }}</span>
            <span class="ft12Black">PLACAS:</span>
            <span> ____________________</span>
            <br />
            <br />
            <br />
          </div>

          <span class="ft12">
              Cabe mencionar que dicho vehículo es propiedad de GPI AUTO COMERCIAL SAPI DE CV, y que lo recibo como
              ARRENDATARIO.</span>
          <div class="col-12 text-center pt-2 icontainer">
            <img src="../Contratos/Logo-GPI.png" class="rounded covered-img" width="70%" style="background-image" />
            <div class="centered ft13 col-12">

              <div class="col-12 text-center pt-5">
                <div class="row text-center">
                  <div class="col-2">
                    <span> </span>
                  </div>

                  <div class="col-4">
                    <br />
                    <br />
                    <br />
                    <span> ENTREGA</span>
                  </div>

                  <div class="col-4">
                    <br />
                    <br />
                    <br />
                    <span> RECIBE</span>
                  </div>

                  <!-- Force next columns to break to new line -->
                  <div class="w-100"></div>
                  <div class="col-2">
                    <span> </span>
                  </div>
                  <div class="col-4">
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <span> ____________________</span>
                  </div>
                  <div class="col-4">
                    <span>
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      ____________________</span>
                  </div>
                  <div class="w-100"></div>
                  <div class="col-2">
                    <span> </span>
                  </div>

                  <div class="col-4">
                    <span>
                      <br />

                      proveedor</span>
                  </div>
                  <div class="col-4">
                    <span>
                      <br />
                      {{ data.nombre_cliente }}</span>
                  </div>
                  <div class="w-100"></div>
                  <div class="col-2">
                    <span> </span>
                  </div>
                  <div class="col-4">
                    <span>
                      <br />
                      <br />
                      <br />
                      <br />
                      TESTIGO</span>
                  </div>
                  <div class="col-4">
                    <span>
                      <br />
                      <br />
                      <br />
                      <br />
                      TESTIGO</span>
                  </div>
                  <div class="w-100"></div>
                  <div class="col-2">
                    <span> </span>
                  </div>

                  <div class="col-4">
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <span> ____________________</span>
                  </div>

                  <div class="col-2">
                    <span>
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      ____________________</span>
                  </div>
                  <div class="w-100"></div>
                  <div class="col-2">
                    <span> </span>
                  </div>
                  <div class="col-4">
                    <span>
                      <br />
                      TESTIGO1</span>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                  </div>
                  <div class="col-4">
                    <span>
                      <br />
                      TESTIGO2</span>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                  </div>
                  <div class="w-100"></div>
                  <div class="w-100"></div>
                  <div class="w-100"></div>


                </div>
              </div>
              <div class="col-12 row">
                <div class="col-1"></div>
                <div class="col border border-dark p-5">
                  <span class="text-center">
                    FOTO1
                  </span>
                </div>
                <div class="col border border-dark p-5">
                  <span class="text-center">
                    FOTO2
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1 row">
          <span class="ft13Black">
            <span>
              <br />
            </span>
          </span>
        </div>
      </div>
    </div>
    <div id="page2-div" class="container interline border page-container">
      <div class="col-12 text-center  icontainer">
        <img src="../Contratos/Logo-GPI.png" class="rounded covered-img" width="70%" style="background-image" />

        <div class="col-12 centered ft13">
          <div class="col-12 row">
            <div class="col-1"></div>
            <div class="col border border-dark p-5">
              <span class="text-center">
                FOTO1
              </span>
            </div>
            <div class="col border border-dark p-5">
              <span class="text-center">
                FOTO2
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../Contratos/style.scss";

.covered-img {
  opacity: 0.2;
}

.container {
  position: relative;
  text-align: center;
  color: black;
}

/* Centered text */
.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/views/Documentos_extra/Acta_Recepcion_Bines_Arrendados.vue